module.exports = __webpack_public_path__ + "img/compact.5f6dab9f.png";